import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'wf-intervention-back-dialog',
  standalone: true,
  imports: [
  ],
  templateUrl: './intervention-back-dialog.component.html',
  styleUrl: './intervention-back-dialog.component.css'
})
export class InterventionBackDialogComponent {
  @Output()
  onPress = new EventEmitter<boolean>() ;

  onConfirmClick()
  {
    this.onPress.emit(true);
  }

  onCancelClick()
  {
    this.onPress.emit(false);
  }
}
